/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Activeto1Inputs */

const vi_activeto1 = /** @type {(inputs: Activeto1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoạt động đến`)
};

/**

* @param {Activeto1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const activeto1 = /** @type {((inputs?: Activeto1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Activeto1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_activeto1(inputs)
});
export { activeto1 as "activeTo" }